import * as StackTrace from 'stacktrace-js'

function reportError (message, file: string|undefined, line: number|undefined, col: number|undefined, stackTrace) {
  fetch('/log-error', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      message,
      file,
      line,
      col,
      stackTrace
    })
  })
}

window.onerror = function (msg, file, line, col, error) {
  if (error) {
    StackTrace.fromError(error).then(stackFrames => {
      const stacktraceString = stackFrames.map((sf) => sf.toString())

      reportError(msg, file, line, col, stacktraceString)
    })
  }
}

function getDimensions () {
  return {
    device: {
      manufacturer: window.navigator.appName,
      model: window.navigator.appCodeName
    },
    page: {
      title: document.title
    },
    system: {
      screen: {
        width: screen.width,
        height: screen.height
      }
    }
  }
}
